/** PasswordInput — text input with a show/hide eye toggle.
 *
 * Drop-in replacement for any <input type="password" />. Pass standard input props
 * (value, onChange, placeholder, required, name, etc.) plus optional `data-testid`.
 *
 * The eye icon appears at the right edge. Click toggles between type="password" and
 * type="text". Caret position is preserved.
 */
import { useState } from "react";
import { Eye, EyeSlash } from "@phosphor-icons/react";

export default function PasswordInput({ className = "", "data-testid": testid = "password-input", ...rest }) {
  const [show, setShow] = useState(false);
  return (
    <div className="relative">
      <input
        {...rest}
        type={show ? "text" : "password"}
        data-testid={testid}
        className={`w-full rounded-lg border border-stone-200 px-3 py-2.5 pr-10 focus:outline-none focus:ring-2 focus:ring-[#f38838]/30 ${className}`}
      />
      <button
        type="button"
        onClick={() => setShow((s) => !s)}
        className="absolute right-2 top-1/2 -translate-y-1/2 p-1.5 text-stone-400 hover:text-stone-700 rounded"
        aria-label={show ? "Hide password" : "Show password"}
        data-testid={`${testid}-toggle`}
        tabIndex={-1}
      >
        {show ? <EyeSlash size={18} weight="bold" /> : <Eye size={18} weight="bold" />}
      </button>
    </div>
  );
}
